<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="svg-frame"
    v-html="svg"
  ></div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { useReceiptSlipPrint } from '@yonarezi/yonarezi3.slip-print'
import { splitRowOptions } from '@/views/composable/useReceiptSplit'

export default {
  props: {
    baseOptions: { type: [Object, null], default: null },
    row: { type: Object, required: true },
  },
  setup(props) {
    const options = computed(() => splitRowOptions(props.baseOptions, props.row))
    const { svg } = useReceiptSlipPrint(options)

    return { svg }
  },
}
</script>

<style scoped>
.svg-frame {
  background: white;
  padding: 8px;
  border-radius: 4px;
}
.svg-frame >>> svg {
  width: 100%;
  height: auto;
  display: block;
}
</style>
